/* eslint-disable no-console */

import { register } from "register-service-worker";

if (import.meta.env.PROD) {
  register(`${import.meta.env.BASE_URL}sw.js`, {
    ready() {
      console.log(
        "App is being served from cache by a service worker.\n" +
          "For more details, visit https://goo.gl/AFskqB"
      );
    },
    cached() {
      console.log("Content has been cached for offline use.");
    },
    async updated() {
      console.log("New content is available; refreshing");
      // Add a unique query parameter to the URL to bust the cache
      // see vue.config.js -> workboxOptions: {  skipWaiting: true  },
      setTimeout(() => {
        //window.location.href = 'http://obs.schwarzl-it.com';
        window.location.reload(true);
      }, 100);
    },
    offline() {
      console.log(
        "No internet connection found. App is running in offline mode."
      );
    },
    error(error) {
      console.error("Error during service worker registration:", error);
    }
  });
}
